function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeft16Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.52979 11.06L8.58312 8L5.52979 4.94L6.46979 4L10.4698 8L6.46979 12L5.52979 11.06Z",
  fill: "currentColor",
  style: {
    transformBox: "fill-box",
    transformOrigin: "50% 50%"
  },
  transform: "matrix(-1, 0, 0, -1, 0, 0.000002)"
}));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik01LjUyOTc5IDExLjA2TDguNTgzMTIgOEw1LjUyOTc5IDQuOTRMNi40Njk3OSA0TDEwLjQ2OTggOEw2LjQ2OTc5IDEyTDUuNTI5NzkgMTEuMDZaIiBmaWxsPSJjdXJyZW50Q29sb3IiIHN0eWxlPSJ0cmFuc2Zvcm0tYm94OiBmaWxsLWJveDsgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDUwJTsiIHRyYW5zZm9ybT0ibWF0cml4KC0xLCAwLCAwLCAtMSwgMCwgMC4wMDAwMDIpIi8+DQo8L3N2Zz4NCg==";
export { SvgChevronLeft16Px as ReactComponent };